exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".max-width___27STi {\n  width: 100% !important;\n  max-width: 800px;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-1233/public/js/components/Modal.less"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iBAAiB;CAClB","file":"Modal.less","sourcesContent":[".max-width {\n  width: 100% !important;\n  max-width: 800px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"max-width": "max-width___27STi"
};